import { GetterTree } from 'vuex';
import { RootState } from '@/plugins/store';
import { AuthenticationState } from './state';

export const getters: GetterTree<AuthenticationState, RootState> = {
    isSignInAzureHasBeenCalled(state): boolean {
        return state.signInAzureHasBeenCalled;
    },
    isSignInAzureIsSuccessful(state): boolean {
        return state.signInAzureIsSuccessful;
    },
    getSignInAzureError(state): string {
        return state.signInAzureError;
    },
    getCodeVerifier(state): string {
        return state.codeVerifier;
    },
    getCode(state): string {
        return state.code;
    },
    getToken(state): string {
        return state.tokenAzure;
    },
    getAccessToken(state): string {
        return state.accessToken;
    },
    getUserEmail(state): string {
        return state.user.email;
    },
    isGhUser(state): boolean {
        return state.user.ghUser;
    },
    getUserFullName(state): string {
        return state.user.fullName;
    },
    getUserIdClient(state): number {
        return state.user.idClient;
    },
    isAcquiringToken(state): boolean {
        return state.acquiringTokenSilent;
    },
    getPortailName(state): string {
        return state.portail;
    },
};
